import { initializeNutasticApp } from '@nutastic/nutastic-react-app';
import { extractElementData, fetchApiData } from '@nutastic/nutastic-react-app/src/utils';
import messages from './i18n/messages';
import App from './components/app/App';
import AppLoading from './components/app/AppLoading';
import WebFont from 'webfontloader';

const init = async () => {
    WebFont.load({
        google: {
            families: [
                'Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,900;1,300;1,400;1,500;1,600;1,700;1,900',
                'Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900'
            ]
        }
    });

    console.log('initializing website');
    await initializeNutasticApp({
        AppComponent: App,
        LoadingComponent: AppLoading,
        initialState: extractElementData(),
        decorateStateFn: fetchApiData,
        loadingDelay: 1000,
        messages,
        reducers: []
    });
};

init();
